import React from 'react';

const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩабвгдежзийклмнопрстуфхцчшщъыьэюя你好世界';
const fonts = ['Arial', 'Georgia', 'Courier New', 'Times New Roman', 'Verdana', 'Impact', 'Comic Sans MS'];
const colors = ['#e0e0e0', '#f0f0f0', '#cccccc', '#dddddd'];

const getRandom = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)];

const BackgroundChars: React.FC = () => {
  const elements = Array.from({ length: 400 }).map((_, i) => {
    const char = chars[Math.floor(Math.random() * chars.length)];
    const font = getRandom(fonts);
    const color = getRandom(colors);
    const size = 4 + Math.random() * 40;
    const top = Math.random() * 100;
    const left = Math.random() * 100;
    const rotate = Math.random() * 360;
    const opacity = 0.6 + Math.random() * 0.12;
    return (
      <span
        key={i}
        style={{
          position: 'absolute',
          top: `${top}%`,
          left: `${left}%`,
          fontFamily: font,
          fontSize: `${size}px`,
          color,
          opacity,
          transform: `rotate(${rotate}deg)`,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      >
        {char}
      </span>
    );
  });

  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 0,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
      aria-hidden="true"
    >
      {elements}
    </div>
  );
};

export default BackgroundChars;
